import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { FavoritesDTO } from "@signature-it/ngx-entity/models";

@Injectable({
    providedIn: 'root'
})
export class FavoritesService {

    protected fUrl = `${this.restUrlsConf.appURL}/account/entity/favorites.json`;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig) { }

    getEntityFavoriteList(): Observable<FavoritesDTO[]> {
        return this.http.get<FavoritesDTO[]>(this.fUrl)
            .pipe(map((res) => FavoritesDTO.createFromArray(res)), catchError((error: any) => throwError(error)));
    }

    removeEntityFavorites(params: object): Observable<FavoritesDTO[]> {
        return this.http.delete<FavoritesDTO[]>(`${this.fUrl}?vars=${params['entity_var'].join(',')}`)
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    addEntityFavorites(data:any) {
        return this.http.post(`${this.fUrl}`, JSON.stringify(data))
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }
}
